import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'


export interface AddRequestParams {
  /** 业务ID */
  business_id?: string
  /** 名称 */
  name: string
  /** IP地址/网段 */
  ip: string
  /** 操作人 */
  operator?: string
  /** 备注 */
  remark?: string
}


export interface DelRequestParams {
  /** 团队ID */
  team_id: string
  /** 业务ID */
  business_ids: string[]
  /** 操作人 */
  operator?: string
}
export interface DetailRequestParams {
  /** 团队ID */
  team_id: string
  /** 关键字搜索 */
  key_word?: string
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
}

export interface List {
  /** 业务ID */
  business_id: string
  /** 名称 */
  name: string
  /** IP地址/网段 */
  ip: string
  /** 备注 */
  remark: string
  /** 创建时间 */
  ctime: string
  /** 更新时间 */
  mtime: string
}

export interface DetailResponseData {
  /** 明细列表 */
  list?: List[]
  /** 总数 */
  total?: number
}
export interface SwitchResponseData {
  /** 开关状态 0-关闭 1-开启 */
  switch?: number
  current_ip: string
}
export interface EditSwitchRequestParams {
  /** 开关状态 0-关闭 1-开启 */
  switch: number
  /** 操作人 */
  operator?: string
}
export interface DeleteResponseData {
  /** 删除结果提示类型 0-无提示 1-锁定警告(当前IP被删除且仍有其它IP,将被踢出) 2-功能关闭通知(删除的是最后一个IP,已自动关闭IP限制) */
  warn_type?: number
}
export enum DeleteWarnType {
  /** 无提示 */
  None = 0,
  /** 锁定警告：当前IP被删除且仍有其它IP，将被踢出 */
  Kickout = 1,
  /** 功能关闭通知：删除的是最后一个IP，已自动关闭IP限制 */
  AutoClosed = 2,
}
@Injectable()
export class TeamIpLimitService {
  constructor(private http: Http) {

  }
  getTeamiplimitDetailAdd(data: AddRequestParams) {
    return this.http.post<void>('/teamiplimit/detail/add', data)
  }
  getTeamiplimitDetailDelete(data: DelRequestParams) {
    return this.http.post<DeleteResponseData>('/teamiplimit/detail/delete', data)
  }
  @ParamsClean()
  @InvokeThrottle()
  getTeamiplimitDetailList (data: DetailRequestParams) {
    return this.http.post<DetailResponseData>('/teamiplimit/detail/list', data)
  }
  getTeamiplimitDetailUpdate (data: AddRequestParams) {
    return this.http.post<void>('/teamiplimit/detail/update', data)
  }
  getTeamiplimitSwitchGet () {
    return this.http.post<SwitchResponseData>('/teamiplimit/switch/get', {})
  }
  getTeamiplimitSwitchUpdate (data: EditSwitchRequestParams) {
    return this.http.post<void>('/teamiplimit/switch/update', data)
  }
}
